// require('dotenv').config();

const apiBase = process.env.REACT_APP_STRAPI_API_URL + "/api/";

let network = {};
network.apiBase = apiBase;

export default network;
